import { call, put } from 'redux-saga/effects';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { openBlankWindow, setWindowLocation } from '../../app/sagas/spaces/SpacesSagaHelpers';
import { Messages } from '../../codegen/Localize';
import { FlowDetailInfo } from '../../ts/models/FlowInfo';
import { EditFlowReduxAction } from '../actions/EditFlowReduxAction';
import { getFlowDetailInfo } from '../FlowsSagaHelpers';

// When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
// Because we are opening a new window in the edit flow saga which is async, to get around the pop up blocker we need
// to open the window first, then the window.location.href can be set asynchronously afterwards
export function* handleEditFlow(action: EditFlowReduxAction) {
  let newWindow: Window = null;
  try {
    newWindow = openBlankWindow();
    const flowDetailInfo: FlowDetailInfo = yield call(getFlowDetailInfo, action.flow.id);
    setWindowLocation(newWindow, flowDetailInfo.editUrl);
  } catch (e) {
    newWindow && newWindow.close();
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
